import { useIsMobile } from "../context/MobileContext"
import {useState, useEffect} from 'react'
import { db } from "../firebase"
import {doc, onSnapshot} from '@firebase/firestore'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CopyDiv from "./CopyDiv";
import { CircularProgress } from "@mui/material";
import QRCode from 'qrcode'


const PixPayment:React.FC<{
    payload: string
    pixDocId:string
}>=({
    payload,
    pixDocId,
})=>{
    const isMobile = useIsMobile()
    const [paymentCompleted, setPaymentCompleted] = useState(false)

    useEffect(()=>{
        if(pixDocId){
            const docRef = doc(db, 'arcalab_orders', pixDocId)
            const unsubscribe = onSnapshot(docRef, (snapshot)=>{
                if(snapshot.exists()){
                    const data = snapshot.data()
                    if(data.status==='paid'){
                        setPaymentCompleted(true)
                        unsubscribe()
                    }
                }
            })
        }
    },[pixDocId])

    useEffect(()=>{
        if(payload){
            if(!isMobile){
                const canvas = document.getElementById('PixQr')
                QRCode.toCanvas(canvas, payload)
            }
        }
    },[payload])

    return(
        <div>
            {!paymentCompleted&&(
                <div>
                    {!isMobile&&(<div>
                    <div style={{fontFamily:'Digital', color:'#fff', marginTop:'5vh', textAlign:'center', marginBottom:'20px'}}>
                        Escaneie o QR Code no App do seu banco
                    </div>
                    <div>
                        {!payload&&(
                            <div>
                                <CircularProgress size={80}/>
                            </div>
                        )}
                        <canvas id='PixQr' height={!payload?0:'auto'}/>
                    </div>
                    </div>
                    )}
                    <div style={{fontFamily:'Digital', color:'#fff', marginTop:'20px', textAlign:'center', marginBottom:'20px'}}>
                        {isMobile?'Realize o pagamento com o pix copia e cola':'Ou utilize o pix copia e cola'}
                    </div>
                    <CopyDiv payload={payload}/>
                </div>
            )||(
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', margin:'50px 0', color:'#fff'}}>
                    <CheckCircleIcon style={{fontSize:'100px',color:'#4bab58', filter:'linear-gradient(90deg,rgba(75, 171, 88, 1) 0%, rgba(30, 143, 53, 1) 100%)'}}/>
                    <span style={{fontSize:'30px'}}>Pagamento Confirmado</span><br/>Sua presença já está confirmada no laboratório.
                </div>
            )}
        </div>
    )
}

export default PixPayment